import { useEffect, useState } from 'react';

interface GentleToastProps {
  message: string | null;
  duration?: number;
  onDismiss?: () => void;
}

/**
 * Auto-dismissing toast for transient failures (save, delete, toggle).
 * Warm amber/neutral styling — no red backgrounds or error icons.
 */
export default function GentleToast({ message, duration = 5000, onDismiss }: GentleToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) {
      setVisible(false);
      return;
    }

    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      onDismiss?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, onDismiss]);

  if (!visible || !message) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 md:left-auto md:right-4 md:bottom-4 md:max-w-sm animate-in slide-in-from-bottom">
      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg p-3 shadow-lg">
        <p className="text-sm text-amber-800 dark:text-amber-200">{message}</p>
      </div>
    </div>
  );
}
